import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Link from 'next/link'
import { AuthActionCreators } from 'app/reducers/AuthRedux'

const linkStyle = {
  marginRight: 15
}

class Header extends Component {
  render() {
    return (
      <div>
        <a href="/" target="_blank"  style={linkStyle}>Home</a>
        <Link href="/about">
          <a style={linkStyle}>About</a>
        </Link>
        <button onClick={this.props.actions.logoutRequest}>Logout</button>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      logoutRequest: AuthActionCreators.logoutRequest
    },
    dispatch
  )
})

export default connect(null, mapDispatchToProps)(Header)
